import { Component, Input, OnInit } from '@angular/core';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { PaymentDetailsInterface } from '../../../models/payment-details.interface';
import { BillService } from '../../../../bills/services/bill.service';
import { UpdateSelectedProcedure} from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { LedgerMappingInterface } from '../../../../bills/models/ledger-mapping.interface';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-payment-express',
  templateUrl: './payment-express.component.html',
  styleUrls: ['./payment-express.component.css'],
  standalone: false
})
export class PaymentExpressComponent implements OnInit {

  @Input()
  amount: number;

  @Input()
  billId: number;

  @Input()
  redirectLink?: string;

  paymentDetailsInterface = {
    errorMessage: null,
    externalId: null,
    redirectLink: this.redirectLink,
    type: 'express',
    procedureType: 'bill',
    procedureCode: ConstsHelper.PROCEDURE_EXPRESS_PAYMENT,
    selectedLine: null,
    payload: {},
    amount: 0,
  } as PaymentDetailsInterface;
  total = 0;
  penaltyAmount: number;
  selectedBills: Array< {
    customerId: string;
    billId: string;
    billAmount: number;
  }> = [];
  step: number;
  ledgerBills: Array<LedgerMappingInterface> = [];
  totalBillsDataLength: number;
  brand = environment.data.brand;

  constructor(
      private billService: BillService,
      private store: Store<any>,
  ) {
  }

  ngOnInit() {
    this.penaltyAmount = 0;
    if (this.brand !== 'coriolis') {
      this.paymentDetailsInterface.payload = {billId: this.billId};
      this.paymentDetailsInterface.externalId = this.billId.toString();
      if (this.brand === 'lacarte') {
        this.billService.getPenaltiesPayment().subscribe(
            response => {
              let i = 0;
              if (response.length > 0) {
                for (const penalty of response) {
                  i++;
                  this.penaltyAmount += penalty.amount;
                  this.paymentDetailsInterface.externalId += '#' + penalty.id;
                  if (i === response.length) {
                    this.amount = parseFloat((this.penaltyAmount + this.amount).toFixed(2));
                    this.paymentDetailsInterface.errorMessage = ConstsHelper.ERROR_MESSAGE_BILL_PAYMENT + ' ' + this.amount + '€';
                    this.paymentDetailsInterface.amount = this.amount;
                  }
                }
              } else {
                this.paymentDetailsInterface.errorMessage = ConstsHelper.ERROR_MESSAGE_BILL_PAYMENT + ' ' + this.amount + '€';
                this.paymentDetailsInterface.amount = this.amount;
              }
            }
        );
      } else {
        this.paymentDetailsInterface.errorMessage = ConstsHelper.ERROR_MESSAGE_BILL_PAYMENT + ' ' + this.amount + '€';
        this.paymentDetailsInterface.amount = this.amount;
      }
    } else {
      this.setStep(1);
      this.totalBillsDataLength = 0;
      const proFleetToken = localStorage.getItem(ConstsHelper.LOCAL_STORAGE_ADMIN_PRO_FEET_TOKEN);
      this.billService.getCustomerLedger().subscribe(
          response => {
            response.main_cid.results.forEach(ledgerResult => {
              if (ledgerResult.is_bill) {
                this.ledgerBills.push(
                    {
                      customerId: response.main_cid.customer_id,
                      amount: ledgerResult.debit_amount,
                      billId: ledgerResult.bill_id,
                      period: this.getPeriod(ledgerResult.period)
                    }
                );
              }
            });
            if (response.linked_cid.length > 0 && proFleetToken) {
              response.linked_cid.forEach(linkedCid => {
                linkedCid.results.forEach(linkedCidLedgerResult => {
                  if (linkedCidLedgerResult.is_bill) {
                    this.ledgerBills.push(
                        {
                          customerId: linkedCid.customer_id,
                          amount: linkedCidLedgerResult.debit_amount,
                          billId: linkedCidLedgerResult.bill_id,
                          period: this.getPeriod(linkedCidLedgerResult.period)
                        }
                    );
                  }
                });
              });
            }
          }
      );
      this.paymentDetailsInterface.errorMessage = ConstsHelper.ERROR_MESSAGE_BILL_PAYMENT + ' ' + this.amount + '€';
    }
  }

  setStep(step: number) {
    if (this.selectedBills.length > 0 || step === 1) {
      this.step = step;
      if (step === 1) {
        localStorage.removeItem('local_storage_payment_express');
        this.paymentDetailsInterface.payload = {bills: []};
        this.paymentDetailsInterface.externalId = '';
      }
      if (step === 2) {
        this.paymentDetailsInterface.amount = this.total;
        for (const selectedBill of this.selectedBills) {
          this.paymentDetailsInterface.payload.bills.push({
            billId: selectedBill.billId,
            amount: selectedBill.billAmount
          }
          );
          this.paymentDetailsInterface.externalId += selectedBill.billId.toString() + '|';
        }
      }
    }
  }

  getPeriod(period: string) {
    const months = [
      { value: '01', name: 'Janvier' },
      { value: '02', name: 'Février' },
      { value: '03', name: 'Mars' },
      { value: '04', name: 'Avril' },
      { value: '05', name: 'Mai' },
      { value: '06', name: 'Juin' },
      { value: '07', name: 'Juillet' },
      { value: '08', name: 'Août' },
      { value: '09', name: 'Septembre' },
      { value: '10', name: 'Octobre' },
      { value: '11', name: 'Novembre' },
      { value: '12', name: 'Décembre' }
    ];
    return months.find(month => month.value === period.substring(4, 6)).name + ' ' + period.substring(0, 4);
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  updateTotal(event: Event, ledger: LedgerMappingInterface) {
    this.total = 0;
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedBills.push({
        customerId: ledger.customerId,
        billId: ledger.billId,
        billAmount: ledger.amount
      });
    } else {
      const index = this.selectedBills.findIndex(bill => bill.billId === ledger.billId);
      if (index > -1) {
        this.selectedBills.splice(index, 1);
      }
    }
    for (const bill of this.selectedBills) {
      this.total += bill.billAmount;
    }
    this.totalBillsDataLength = JSON.stringify(this.selectedBills).length;
  }

  isChecked(billId: string) {
    return this.selectedBills.findIndex(bill => bill.billId === billId) !== -1;
  }
}
